import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckVersions } from '@api/hitoryCheck';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithArray } from '@utils/formatter';

import { ICMMavenirVendor } from '@interfaces/cmModule/cmModule';
import { TCMVersionsDTO } from '@interfaces/cmModule/dto/cmModuleDTO';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_VERSIONS } from '@constants/queryKeys';

type TUseQueryHistoryCheckVersions = ICMMavenirVendor & TCMVersionsDTO

interface IUseQueryHistoryCheckVersionsReturnValue {
	versionsOptions: TSelectOption[];
	isLoadingVersionsOptions: boolean;
}

export const useQueryHistoryCheckVersions = (
	params: TUseQueryHistoryCheckVersions,
): IUseQueryHistoryCheckVersionsReturnValue => {
	const {
		vendor,
		nodes,
		isMavenirVendor,
	} = params;

	const {
		data,
		isFetching,
		isLoading,
	} = useQuery<string[], TSelectOption[]>({
		queryKey: [HISTORY_CHECK_VERSIONS, params],
		queryFn: extractQueryParams(getHistoryCheckVersions),
		select: (options) => optionsFormattedWithArray(options),
		enabled: [!!nodes, !!vendor, isMavenirVendor],
		...refetchOptions,
	});

	return {
		versionsOptions: data || [],
		isLoadingVersionsOptions: (isLoading && !!data) || isFetching,
	};
};
